import { isChromium } from '@datadog/browser-core'

const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)

export const calculateZoom = () => {
  if (isChromium()) return chromiumZoomMetadata()
  return {
    pageZoom: Math.round(window?.visualViewport?.scale * 100),
  }
}

const chromiumZoomMetadata = () => {
  if (isMobile) {
    return {
      // chrome://settings/appearance -> 'Customize Fonts' or chrome://settings/fonts
      fontSize: window
        .getComputedStyle(document.getElementsByTagName('html')[0])
        .getPropertyValue('font-size'),
      // iPhone: open Chrome. 'Settings' -> 'Zoom Text...'
      fontSizeZoom: getComputedStyle(document.querySelector('body'))['-webkit-text-size-adjust'],
      pageZoom: Math.round((window.screen.width / window.innerWidth) * 100),
    }
  }

  return {
    // chrome://settings/appearance -> 'Customize Fonts' or chrome://settings/fonts
    fontSize: window
      .getComputedStyle(document.getElementsByTagName('html')[0])
      .getPropertyValue('font-size'),
    pageZoom: Math.round((window?.frames?.devicePixelRatio * 100) / 2),
  }
}
